export * from './components';

export const version = '@antv/s2-react-components-v2.1.2';
